var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95109 4.66974L4.25085 13.075L5.097 13.0494L4.79724 4.64419L3.95109 4.66974Z",
    fill: "#F90B0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82934 13.0478L9.677 13.0734L9.97674 4.66886L9.12908 4.64326L8.82934 13.0478Z",
    fill: "#F90B0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38539 4.65771H6.53882V13.0622H7.38539V4.65771Z",
    fill: "#F90B0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9606 2.13418H10.2547L9.87351 1.57668C9.50907 1.08554 8.93962 0.751595 8.29881 0.65728C7.41428 0.552485 6.54114 0.552485 5.61409 0.658677C4.95961 0.755786 4.3727 1.10231 4.04015 1.59135L3.66888 2.13418H0.962891V2.91525H1.26963L1.90285 13.8775C1.93701 14.8241 2.71221 15.6052 3.74556 15.7309C4.80776 15.8581 5.87755 15.9217 6.94886 15.9217C8.02017 15.9217 9.09224 15.8581 10.1529 15.7309C11.1658 15.6087 11.9516 14.8318 12.0214 13.8837L12.6554 2.91455H12.9606V2.13418ZM4.75841 2.00284C4.95733 1.70802 5.33848 1.48865 5.73253 1.43066C6.57303 1.33495 7.37632 1.33355 8.17809 1.42927C8.57746 1.48725 8.94038 1.70103 9.16664 2.00284L9.25547 2.13418H4.67033L4.75841 2.00284ZM11.1734 13.8404C11.1331 14.414 10.6563 14.8842 10.0436 14.9582C7.9898 15.2042 5.90716 15.2042 3.85641 14.9582C3.24521 14.8849 2.76992 14.4077 2.75018 13.8432L2.11772 2.91595H11.8051L11.1734 13.8404Z",
    fill: "#F90B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/Delete_icon.c8a0b5a162f5c11abf611f7525f3fa51.svg";
export { ForwardRef as ReactComponent };